import ApiError from "./ApiError";

export default class FieldError extends ApiError {
	constructor(original,errorResponse) {
		super(original,errorResponse);
		this.fieldErrors = errorResponse.field_errors;
	}
}
